export const PRODUCT_TITLE = 'Player Support'
export const CREATE_QUERY = 'Create Query'
export const LIST_QUERIES = 'List Queries'
export const LIST_QUERY_REQUEST_RECORDS = 'List Query Request Records'
export const LIST_DISCARDED_LOGS = 'List Discarded Logs'
